<template>
  <div>
    <!-- Start leftpart -->
    <div class="leftpart">
      <div class="leftpart_inner">
        <div class="logo">
          <router-link to="/"
            ><img src="../assets/img/logo/dark.png" alt=""
          /></router-link>
        </div>
        <!-- End .logo -->
        <div class="menu modern-menu">
          <a
            v-on:click="activetab = 1"
            :class="['menu-item', activetab === 1 ? 'active' : '']"
          >
            <img
              class="svg"
              src="../assets/img/svg/home-run.svg"
              alt="homerun"
            />
            <span class="menu_content">Home</span>
            <span class="menu-indicator"></span>
          </a>
          <a
            v-on:click="activetab = 2"
            :class="['menu-item', activetab === 2 ? 'active' : '']"
          >
            <img class="svg" src="../assets/img/svg/avatar.svg" alt="avatar" />
            <span class="menu_content">About</span>
            <span class="menu-indicator"></span>
          </a>
          <a
            v-on:click="activetab = 3"
            :class="['menu-item', activetab === 3 ? 'active' : '']"
          >
            <img
              class="svg"
              src="../assets/img/svg/briefcase.svg"
              alt="briefcase"
            />
            <span class="menu_content">Gallery</span>
            <span class="menu-indicator"></span>
          </a>
          <a
            v-on:click="activetab = 5"
            :class="['menu-item', activetab === 5 ? 'active' : '']"
          >
            <img class="svg" src="../assets/img/svg/mail.svg" alt="mail" />
            <span class="menu_content">Contact</span>
            <span class="menu-indicator"></span>
          </a>
        </div>
        <div class="copyright">
          <p>
            &copy; {{ new Date().getFullYear() }} Touch Designs
          </p>
        </div>
        <!-- End copyright -->
      </div>
    </div>
    <!-- End leftpart -->

    <!-- Start rightpart -->
    <div class="rightpart">
      <div class="rightpart_in">
        <div class="tokyo_tm_section">
          <div class="container">
            <div v-if="activetab === 1" class="tabcontent">
              <Home />
            </div>
            <!-- End Home tabcontent -->
            <div v-if="activetab === 2" class="tabcontent">
              <About />
            </div>
            <!-- End About tabcontent  -->
            <div v-if="activetab === 3" class="tabcontent">
              <Portfolio />
            </div>
            <!-- End Portfolio tabcontent -->
            <div v-if="activetab === 4" class="tabcontent">
              <News />
            </div>
            <!-- End News tabcontent -->
            <div v-if="activetab === 5" class="tabcontent">
              <Contact />
            </div>
            <!-- End Contact tabcontent -->
          </div>
        </div>
      </div>
    </div>
    <!-- End rightpart -->
  </div>
</template>

<script>
  import Home from "../components/Home";
  import About from "../components/About";
  import Portfolio from "../components/Portfolio";
  import News from "../components/News";
  import Contact from "../components/Contact";
  export default {
    components: {
      Home,
      About,
      Portfolio,
      News,
      Contact,
    },
    data() {
      return {
        activetab: 1,
      };
    },
  };
</script>

<style lang="scss" scoped>
.logo {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  margin-bottom: 20px;

  a {
    display: block;
  }

  img {
    display: block;
    max-width: 100%;
    height: auto;
  }
}

.modern-menu {
  .menu-item {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px 20px;
    margin-bottom: 8px;
    border-radius: 12px;
    transition: all 0.3s ease;
    cursor: pointer;
    overflow: hidden;

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 4px;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      transform: scaleY(0);
      transition: transform 0.3s ease;
    }

    .svg {
      width: 20px;
      height: 20px;
      transition: all 0.3s ease;
      filter: grayscale(1);
      opacity: 0.6;
    }

    .menu_content {
      font-size: 15px;
      font-weight: 500;
      transition: all 0.3s ease;
      color: #666;
    }

    .menu-indicator {
      position: absolute;
      right: 16px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      opacity: 0;
      transform: scale(0);
      transition: all 0.3s ease;
    }

    &:hover {
      background: rgba(102, 126, 234, 0.05);
      transform: translateX(4px);

      .svg {
        filter: grayscale(0);
        opacity: 1;
        transform: scale(1.1);
      }

      .menu_content {
        color: #667eea;
      }
    }

    &.active {
      background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);

      &::before {
        transform: scaleY(1);
      }

      .svg {
        filter: grayscale(0);
        opacity: 1;
      }

      .menu_content {
        color: #667eea;
        font-weight: 600;
      }

      .menu-indicator {
        opacity: 1;
        transform: scale(1);
      }
    }
  }
}

.rightpart {
  .tabcontent {
    animation: fadeInContent 0.5s ease-out;
  }
}

@keyframes fadeInContent {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.dark {
  .modern-menu {
    .menu-item {
      .menu_content {
        color: #aaa;
      }

      &:hover {
        background: rgba(139, 156, 255, 0.1);

        .menu_content {
          color: #8b9cff;
        }
      }

      &.active {
        background: linear-gradient(135deg, rgba(139, 156, 255, 0.15) 0%, rgba(139, 156, 255, 0.1) 100%);

        .menu_content {
          color: #fff;
        }
      }
    }
  }
}

@media (max-width: 1040px) {
  .modern-menu {
    .menu-item {
      padding: 12px 16px;

      .menu_content {
        font-size: 14px;
      }
    }
  }
}
</style>
